import { ZoneCapacity } from "../model/ZoneCapacity";

export class ZoneCapacityJSONParser {

    public static parse(data: any): ZoneCapacity[] {
        let zones: ZoneCapacity[] = [];
        let parsedData: any = JSON.parse(data);
        let zone: ZoneCapacity;

        if ("zones" in parsedData) {
            for (let i = 0; i < parsedData.zones.length; i++) {
                zone = this.parseZone(parsedData.zones[i]);
                zones.push(zone);
            }
        }
        return zones;
    }

    private static parseZone(data: any): ZoneCapacity {
        let zone: ZoneCapacity = new ZoneCapacity();
        zone.zoneId = ("zoneId" in data) ? data.zoneId : -1;
        zone.remainingRegistrationCapacity = ("remainingRegistrationCapacity" in data) ? data.remainingRegistrationCapacity : 100; // this value is used to calculate capacity ratio ( specified by Zone_capacities.json) if value not available  just assume full capacity

        return zone;
    }
}
